// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".agreement[data-v-022924b4] {\n  font-size: 0.7rem;\n  text-align: center;\n  line-height: 1.4;\n  color: #6a6d82;\n  margin-bottom: 1rem;\n}", ""]);
// Exports
module.exports = exports;
